const urlFormatter = (match, i) => {
  return <a key={i} className='sndbx-fm-url' href={match} target='_blank' rel='noreferrer'>
      <span className='sndbx-fm-ellipsis'>
        {match.replace(/(https?:\/\/|www\.)/g, '')}
      </span>
      <i style={{marginLeft: '5px'}} className="far fa-external-link-alt"></i>
    </a>
}

const quotationCleaner = (sentence) => {
  if(sentence) {
    sentence = sentence.trim()
    if (sentence.length >= 2 && sentence.charAt(0) === '"' && sentence.charAt(sentence.length - 1) === '"') {
      return sentence.slice(1, -1)
    } else {
      return sentence
    }
  } else {
    return sentence
  }
}

const normalizeMathDelimiters = (markdown) => {
  if(!markdown) return null
  return markdown
    .replace(/\\\[(.*?)\\\]/gs, (_, content) => `$$${content}$$`)
    .replace(/\\\((.*?)\\\)/gs, (_, content) => `$$${content}$$`)
}

function parseMarkdownLinks(content) {
  const links = [];
  let pos = 0;
  
  while (pos < content.length) {
    // Find opening bracket
    const labelStart = content.indexOf('[', pos)
    if (labelStart === -1) break
    
    // Find closing bracket
    const labelEnd = content.indexOf(']', labelStart)
    if (labelEnd === -1) break
    
    // Check if followed by opening parenthesis
    if (content[labelEnd + 1] !== '(') {
      pos = labelEnd + 1
      continue
    }
    
    const urlStart = labelEnd + 2;
    let urlEnd = urlStart
    let openParens = 1
    
    // Find the matching closing parenthesis
    while (urlEnd < content.length && openParens > 0) {
      if (content[urlEnd] === '(') {
        openParens++
      } else if (content[urlEnd] === ')') {
        openParens--
      }
      if (openParens > 0) urlEnd++
    }
    
    if (openParens === 0) {
      const label = content.substring(labelStart + 1, labelEnd)
      const href = content.substring(urlStart, urlEnd)
      
      // Only add if it's a cloud.sellagen.com URL
      if (href.startsWith('https://cloud.sellagen.com/')) {
        links.push({ label, href })
      }
      
      pos = urlEnd + 1
    } else {
      // No matching closing parenthesis was found
      pos = labelEnd + 1
    }
  }
  
  return links
}

function parseMarkdownImages(content) {
  if (!content || typeof content !== 'string') {
    return [];
  }
  
  // Enhanced regex to handle more edge cases:
  // - Optional whitespace around alt text and URL
  // - URLs with parentheses (using balanced parentheses or escaped ones)
  // - Empty alt text
  // - URLs with spaces (though not standard markdown)
  const imageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
  
  const images = [];
  let match;
  
  while ((match = imageRegex.exec(content)) !== null) {
    const value = match[1].trim(); // Trim whitespace from alt text
    const url = match[2].trim();   // Trim whitespace from URL
    
    // Only add if URL is not empty (alt text can be empty)
    if (url) {
      images.push({ value, url });
    }
  }
  
  return images;
}

export {urlFormatter, quotationCleaner, normalizeMathDelimiters, parseMarkdownLinks, parseMarkdownImages}